import React, { Component } from 'react';
import axios from 'axios';
import screenfull from 'screenfull';

import Sidebar from '../../components/sidebar';
import Menu from '../../components/menu';
import Gallery from '../../components/gallery';

class Works extends Component {
  constructor() {
    super()

    this.state = {
      sidebarHidden: true,
      fullscreen: false,
      data: []
    }

    this.toggleSidebar = this.toggleSidebar.bind(this)
    this.toggleFullscreen = this.toggleFullscreen.bind(this)
    this.onZoomChange = this.onZoomChange.bind(this)
  }

  componentDidMount() {
    document.body.classList.toggle('is-works');
    const { id } = this.props.match.params;

    this.loadWorks(id)
  }

  componentWillUnmount() {
    document.body.classList.remove('is-works');
  }

  componentWillReceiveProps(nextProps) {
    const { id } = nextProps.match.params;

    this.gallery.slider.slickGoTo(0)
    this.loadWorks(id)
  }

  toggleSidebar() {
    this.setState((prevState) => ({
      sidebarHidden: !prevState.sidebarHidden
    }));
  }

  toggleFullscreen() {
    screenfull.toggle()

    this.setState((prevState) => ({
      fullscreen: !prevState.fullscreen
    }))
  }

  loadWorks(id) {
    const url = `/data/${id}.json`;

    axios.get(url)
      .then((r) => {
        this.setState({
          data: r.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onZoomChange({ name }) {
    this.setState((prevState) => {
      return prevState.data.map((item) => {
        if (item.name === name) {
          item.zoomActive = !item.zoomActive

          return item;
        }

        return item;
      })
    })
  }

  renderNavbar() {
    return (
      <div className="navbar">
        <a onClick={this.toggleSidebar} className="navbar__link navbar__link--toggler">
          <i className="icon icon--menu"></i>
        </a>
        <a onClick={this.toggleFullscreen} className="navbar__link navbar__link--fullscreen">
          <i className="icon icon--fullscreen"></i>
        </a>
      </div>
    )
  }

  render() {
    const { data, sidebarHidden } = this.state;
    const { id } = this.props.match.params;

    return (
      <div className="page">
        { this.renderNavbar() }

        <Sidebar hidden={sidebarHidden}>
          <Menu modifier="sidebar" intro={true} handleOnClick={this.toggleSidebar} />
        </Sidebar>

        <Gallery
          ref={(c) => this.gallery = c }
          data={data}
          namespace={id}
          onZoomChange={this.onZoomChange}
        />
      </div>
    )
  }
};

export default Works;



// WEBPACK FOOTER //
// ./src/views/works/index.js